import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms'; // Import required modules

@Component({
  selector: 'app-insurance',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.css'],
})
export class InsuranceComponent implements OnInit {
  form: FormGroup;
  showTitleError = false;
  showFileError = false;

  constructor(private fb: FormBuilder) {
    // Initialize the form group in the constructor
    this.form = this.fb.group({
      insuranceTitle: [''],
      insuranceDescription: ['', Validators.required],
      insuranceFile: [null],
    });
  }

  // File state
  uploadedFile: File | null = null;

  ngOnInit() {
    // Initialize form with form controls
    this.form = new FormGroup({
      
      insuranceTitle: new FormControl(''),
      insuranceDescription: new FormControl('', [Validators.required]),
      insuranceFile:new FormControl ([null]),
    });
  }

  // Handle file upload
  onFileUpload(event: any) {
    this.uploadedFile = event.target.files[0];
    console.log('Uploaded File: ', this.uploadedFile);

    if (this.uploadedFile) {
      // Make insuranceTitle required when a file is uploaded
      this.form.get('insuranceTitle')?.setValidators([Validators.required]);
      this.form.get('insuranceTitle')?.updateValueAndValidity(); // Trigger validation
    } else {
      // Remove required validator if no file is uploaded
      this.form.get('insuranceTitle')?.clearValidators();
      this.form.get('insuranceTitle')?.updateValueAndValidity(); // Trigger validation
    }
  }
  // Handle form submission
  onSubmit() {
    // Mark all controls as touched to trigger validation errors
    this.form.markAllAsTouched();

    // Check form validity
    if (this.form.valid) {
      const formData = this.form.value;

      // Prepare data for submission
      const dataToSubmit = new FormData();
      // dataToSubmit.append('insuranceDescription', formData.insuranceDescription);

      if (this.uploadedFile) {
        dataToSubmit.append('insuranceFile', this.uploadedFile);
        dataToSubmit.append('insuranceTitle', formData.insuranceTitle); // Title is required if file is uploaded
      }

      console.log('Form submitted successfully with data:', formData);

      // Send data to API (example)
      // this.http.post('your-api-url', dataToSubmit).subscribe(response => {
      //   console.log('Response:', response);
      // });
    } else {
      // Show error if file is uploaded but title is missing
      if (this.uploadedFile && !this.form.get('insuranceTitle')?.valid) {
        console.log('Title is required when a file is uploaded');
      }
    }
  }
}
